import * as React from 'react';

import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';

import { IProps } from './interfaces';

import styles from './MultipleChoice.module.styl';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const ITEM_HEIGHT_MULTIPLIER = 4.5;
const ITEM_WIDTH = 250;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * ITEM_HEIGHT_MULTIPLIER + ITEM_PADDING_TOP,
      width: ITEM_WIDTH,
    },
  },
};

class MultipleChoice extends React.Component<IProps> {
  public render() {
    const { input, meta, title } = this.props;

    const options = this.getOptions();

    const values = this.getValues(input.value);

    return (
      <FormControl
        variant="outlined"
        fullWidth={true}
        margin="normal"
        error={meta.touched && meta.error}
      >
        <InputLabel htmlFor={input.name} className={styles.label}>
          {title}
        </InputLabel>
        <Select
          multiple={true}
          value={values}
          input={this.getInput()}
          onChange={this.handleChange}
          renderValue={this.renderedValue}
          MenuProps={MenuProps}
        >
          {options.map(this.renderOptions)}
        </Select>
        {meta.touched && meta.error && (
          <FormHelperText>{meta.error}</FormHelperText>
        )}
      </FormControl>
    );
  }

  private readonly getInput = () => {
    const {
      input: { name },
    } = this.props;

    return <OutlinedInput labelWidth={0} id={name} />;
  };

  private readonly getOptionName = (options: any, item: any) => {
    const { optionsMap } = this.props;

    const result = options.find((option: any) =>
      optionsMap ? option[optionsMap.value] === item : option.value === item,
    );

    return result
      ? result.name || (optionsMap ? result[optionsMap.label] : result.label)
      : 'UNKNOWN OPTION';
  };

  private readonly getOptions = () => {
    const { options, dictionary } = this.props;

    return options || this.props[dictionary as keyof IProps] || [];
  };

  private readonly getValues = (values: unknown) => {
    const { optionsMap } = this.props;

    if (!Array.isArray(values)) {
      return [];
    }

    return values.map(item => {
      if (typeof item === 'string') {
        return item;
      }

      return optionsMap ? item[optionsMap.value] : item.value;
    });
  };

  private readonly handleChange = (event: any) => {
    const {
      input: { onChange },
    } = this.props;

    onChange(event.target.value);
  };

  private readonly handleDelete = (id: string) => {
    const {
      input: { value = [], onChange },
    } = this.props;

    const newValues = value.filter((item: any) => item !== id);

    onChange(newValues || []);
  };

  private readonly renderedValue = (selected: any) => {
    const options = this.getOptions();

    return (
      selected.map && (
        <div className={styles.selectedOptionsWrapper}>
          {selected.map((item: any) => {
            const handleDelete = () => this.handleDelete(item);

            return (
              <Chip
                className={styles.chip}
                onDelete={handleDelete}
                key={item}
                label={this.getOptionName(options, item)}
              />
            );
          })}
        </div>
      )
    );
  };

  private readonly renderOptions = (option: Record<string, string>) => {
    const { optionsMap } = this.props;

    return (
      <MenuItem
        key={optionsMap ? option[optionsMap.value] : option.value}
        value={optionsMap ? option[optionsMap.value] : option.value}
      >
        {optionsMap ? option[optionsMap.label] : option.label}
      </MenuItem>
    );
  };
}

export default MultipleChoice;
